import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
	palette: {
		primary: {
			main: '#00011f',
		},
		secondary: {
			main: '#E5E5E5',
			contrastText: '#4e4ba6'
		},
		white: '#FFFFFF',
	},

	components: {
		MuiSlider: {
			styleOverrides: {
				rail: {
					backgroundColor: '#03DAC6'
				},
				track: {
					backgroundColor: '#00696B'
				},
				thumb: {
					backgroundColor: '#00696B'
				},
			}
		},
		MuiTab: {
			styleOverrides: {
				root: {
					minWidth: 'auto',
					maxWidth: 'auto',
					'@media (min-width: 0px)': {
						minWidth: 'auto',
						maxWidth: 'auto',
					}
				}
			}
		},
		MuiFormControl: {
			styleOverrides: {
				root: {
					marginBottom: '20px'
				}
			}
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					backgroundColor: '#FFFFFF !important',
					borderRadius: '4px 4px 0px 0px',
				},
			}
		},
		MuiInputLabel: {
			styleOverrides: {
				shrink: {
					// color: '#6202EE'
				},
			}
		},
		MuiRadio: {
			styleOverrides: {
				root: {
					padding: '0'
				}
			}
		}
	},

	config: {
		containerWidth: '1280px',
	}
})
